import request from '@/utils/request'

// getFileList
export function getFileList(param) {
  let data = param
  return request({
    url: `/inspection/v80a1040Popup/getFileList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// getAddList
export function getAddList(param) {
  let data = param
  return request({
    url: `/inspection/v80a1040Popup/getAddList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
// v80a1040Save
export function v80a1040Save(param) {
  let data = param
  return request({
    url: `/inspection/v80a1040Popup/v80a1040Save`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// fileNoAirTest
export function fileNoAirTest(param) {
  let data = param
  return request({
    url: `/inspection/v80a1040Popup/fileNoAirTest`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80a1040UploadFile
export function v80a1040UploadFile(param) {
  let data = param
  return request({
    url: `/inspection/v80a1040Popup/v80a1040UploadFile`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80a1040UpdateReason
export function v80a1040UpdateReason(param) {
  let data = param
  return request({
    url: `/inspection/v80a1040Popup/v80a1040UpdateReason`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}

// v80a1040DelFile
export function v80a1040DelFile(param) {
  let data = param
  return request({
    url: `/inspection/v80a1040Popup/v80a1040DelFile`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}
